<template>
  <div class="chat-main">
    <p v-if="selectedChatbot && selectedChatbot.name" class="current-mode">Current model: {{ selectedChatbot.name }}</p>
  </div>
</template>

<script>
export default {
  name: 'ChatMain',
  props: {
    selectedChatbot: Object
  },
};
</script>

<style scoped>
.chat-main {
  width: 100%;
  max-width: var(--welcome-max-width, 640px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 var(--space-lg);
  box-sizing: border-box;
}

.current-mode {
  margin: var(--space-lg) 0 0 0;
  font-size: var(--text-xs, 11px);
  color: var(--text-muted, #999);
  text-align: center;
}

</style>
